export const getDynamicJson = (pageJson, layoutJson) => {

    if(layoutJson?.isDefault && layoutJson?.components?.length > 0)
    {

        const dataWithOutHeaderFooter = pageJson?.components?.filter((i) => (i.name != 'Header'))?.filter((i) => (i.name != 'Footer'));

        let obj = {}
        obj = {...pageJson}
        obj['components'] = dataWithOutHeaderFooter

        return obj;

    }
    else
    {
        return pageJson;
    }

}